import axios from "axios";
import { setCookie, getCookie, deleteCookie } from "cookies-next";
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const authService = {
  async sendOTP(PhoneNumber: string) {
    const response = await axios.get(
      `${API_BASE_URL}/login_number/${PhoneNumber}`
    );
    return response;
  },
  async fetchUserRole(bulkUserID: string | null) {
    const response = await axios.get(
      `${API_BASE_URL}/fetch_userRole/${bulkUserID}`
    );
    return response;
  },
  async fetchUser(bulkUserID: string | null) {
    const response = await axios.get(
      `${API_BASE_URL}/user/${bulkUserID}`
    );
    return response;
  },

  async verifyOTP(PhoneNumber: string, OTP: string) {
    const response = await axios.get(
      `${API_BASE_URL}/login_number_otp/${PhoneNumber}/${OTP}`
    );
    // Store token in cookies after successful login
    if (response.data?.token && response.data?.PhoneNumber) {
      setCookie("authToken", response.data.token, {
        maxAge: 60 * 60 * 24 * 7, // 7 days
        path: "/",
        secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
        httpOnly: false, // Set to true if using server-side authentication
      });

      setCookie("userPhone", response.data.PhoneNumber, {
        maxAge: 60 * 60 * 24 * 7, // 7 days
        path: "/",
        secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
        httpOnly: false, // Set to true if using server-side authentication
      });
      setCookie("userExists", response.data.UserExists, {
        maxAge: 60 * 60 * 24 * 7, // 7 days
        path: "/",
        secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
        httpOnly: false, // Set to true if using server-side authentication
      });
      if (response?.data?.UserID) {
        setCookie("bulkUserID", response?.data?.UserID, {
          maxAge: 60 * 60 * 24 * 7, // 7 days
          path: "/",
          secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
          httpOnly: false, // Set to true if using server-side authentication
        });
      }
      if (response?.data?.creditLimit) {
        setCookie("bulkCreditLimit", response?.data?.creditLimit, {
          maxAge: 60 * 60 * 24 * 7, // 7 days
          path: "/",
          secure: process.env.NEXT_PUBLIC_NODE_ENV === "production",
          httpOnly: false, // Set to true if using server-side authentication
        });
      }
    }

    return response;
  },

  logout() {
    deleteCookie("authToken");
    deleteCookie("userPhone");
    deleteCookie("userExists");
    deleteCookie("bulkUserID");
    deleteCookie("bulkCreditLimit");
  },

  getToken() {
    return getCookie("authToken");
  },
};
